<template>
    <div>
      <design-deadline-report-list></design-deadline-report-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  